import { remove } from '@core/api/baseApi';
import { RemoveUserResponse } from '@core/types';

export const deleteUser = async (userUid: string): Promise<RemoveUserResponse> => await remove(`/Users/${userUid}`);

